module.exports = __webpack_public_path__ + "img/DE00087.d08b32d5.png";